/* lib/safeUrl.js — белый список схем URL для рендера ссылок из недоверенного Markdown.
   Контент ленты приходит из LLM/файлов → URL может содержать javascript:/data:/vbscript:.
   safeUrl(url) возвращает безопасный href либо null (тогда ссылку рисуем как текст). */

  // схемы, которые разрешаем как абсолютные ссылки
  const ALLOWED_SCHEMES = ['http:', 'https:', 'mailto:', 'tel:'];
  // опасные схемы (после очистки от пробелов/управляющих символов)
  const DANGEROUS_RE = /^(javascript|data|vbscript):/i;

  const safeUrl = (url) => {
    if (url == null) return null;
    // выкидываем все управляющие символы и пробелы (\t \n \r \0 и DEL),
    // чтобы нельзя было обойти проверку схемы обфускацией вида "java\tscript:"
    let u = String(url).replace(/[\x00-\x20\x7f]/g, '').trim();
    if (!u) return null;

    // протокол-относительный "//host" формально начинается с '/', но это
    // внешняя ссылка В ОБХОД белого списка схем (унаследует http/https страницы).
    // Не относительный путь — рендерим как текст, а не ссылку.
    if (u.slice(0, 2) === '//') return null;

    // относительные / якорные / query — всегда безопасны
    if (u[0] === '/' || u[0] === '#' || u[0] === '?') return u;

    // явно опасные схемы
    if (DANGEROUS_RE.test(u)) return null;

    // если есть схема (scheme:) — пускаем только из белого списка
    const m = u.match(/^([a-z][a-z0-9+.-]*):/i);
    if (m) {
      const scheme = m[1].toLowerCase() + ':';
      return ALLOWED_SCHEMES.includes(scheme) ? u : null;
    }

    // без схемы (например "example.com/path" или "foo") — относительный путь, безопасно
    return u;
  };

export { safeUrl };
